module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "title": "XI"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fond_1",
      "src": "images/fond.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("AUTHOR’S PREFACE")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("THIS PROJECT REPRESENTS")]), _vm._v(" my own theological journey. Having grown up in a conservative, dispensationalist home and having graduated from The Master’s College, I was taught that Israel and the church were two different people groups. Two separate entities with two separate destinies. The church was now living in something of an unexpected parenthesis in the broad story line of the Bible. Predictably, I grew to envy the nation of Israel, as I wanted to inherit "), _c('i', [_vm._v("all")]), _vm._v(" of God’s promises and fully participate in his program. I didn’t want to be a second-class citizen in the people of God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I went on to study Bible and theology in graduate school, where I learned about “biblical theology” and how the two Testaments properly relate to one another. Israel and the church were not separate but were unified in the person of Christ. Jesus of Nazareth is the true Israel of God, who reconstituted the people of God in himself. So, the church, composed of believing Jews and Gentiles, is the restored people of God, true Israel, because of their identification with him.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A tectonic shift had taken place in how I read the Bible, and one of the things that shaped my understanding was examining the use of the Old Testament in the New. The apostles quote the Old Testament approximately three hundred times and allude to the Old Testament well over a thousand times. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "title": "XII"
    }
  }, [_vm._v("So, when the apostles instruct their congregations, do they plead with them to read the Old Testament as observers or as participants? I believe it’s the latter.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This project is, therefore, the fruit of my personal struggle with Israel and the church. Moreover, I’ve written this book for my students and friends who also are coming to grips with their own identity in Christ. The more I read the New Testament, the more I realize how fundamental this principle was for the early church. The apostles never grew tired of reminding their congregations of working out their identity as the restored people of God and the true Israel.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’m thankful for my wife, Nikki, and my kids, Judah and Simon, who encourage me beyond measure. My understanding of identity has been sharpened through them. I’m also thankful for my church, Highlands Presbyterian, in Madison, Mississippi, which has given me ample opportunities to teach on this subject. Our friends there warm our hearts toward Christ. I’m thankful for InterVarsity Press for accepting this project. Dan Reid, though now retired, was incredibly encouraging in the initial stages of this project and the ESBT series as a whole. I’m also grateful for Anna Gissing at InterVarsity and her invaluable input. Finally, I’m indebted to Michael Morales and Guy Waters for reading portions of this manuscript and giving me helpful feedback.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Above all, I’m thankful to God, who gave me the desire to pen this project and the energy to complete it. May all glory and honor be his.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To keep the project accessible, my default translation and chapter outlines rely on the New International Version (2011). I often italicize words or phrases within the English translation to demonstrate emphasis or mark parallel wording with the Old Testament. Most of the time these parallels indicate that a New Testament passage is alluding to or quoting the Old Testament.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('i', [_vm._v("Benjamin L. Gladd")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0